import { Box, TextField } from "@mui/material";
import React, { useEffect, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setState,setTotalValues } from "./defineSlice";
import './Define.css'
import {
	removeComma,
	isWeekColumnEditable,
	rowDepletionModelKey,
	shouldShowBlankWeekPlaceholder,
	findGridRowByCustomerSku,
	commitGridDataUpdate,
} from "./defineUtils";
import debounce from 'lodash/debounce';
import { QUOTA_CELL_DEBOUNCE_MS, useQuotaCellInputSync } from "./useQuotaCellInput";

export default function TableCellWeek5(params) {
   const dispatch = useDispatch();
   const define = useSelector((state) => state.define);
   const { gridData, gridDataFiltered, selectedDepletionPeriodType } = define;
   const gridDataRef = useRef(gridData);
   const gridDataFilteredRef = useRef(gridDataFiltered);
   gridDataRef.current = gridData;
   gridDataFilteredRef.current = gridDataFiltered;
   const rowDm = rowDepletionModelKey(params.row);
   const periodLabel = String(
      selectedDepletionPeriodType?.depletionPeriodType ?? ""
   ).toLowerCase();
   const isFourWeekPeriod = periodLabel.includes("4-week");
   const isFiveWeekPeriod = periodLabel.includes("5-week");
   const cellInput = useQuotaCellInputSync(params.row.weekly5);
   const { setDraft, displayValue, onFocus, onBlur } = cellInput;
   const customerID = params.row.customerID;
   const customerGroupID = params.row.customerGroupID;
   const productGroupID = params.row.productGroupID;
   const skuid = params.row.skuid;

   function updateGrid(hasError, w) {
      dispatch(setState("isFailed", true));
      dispatch(setState("isFailed_Info", "Quota value has been updated as week 5 value was edited."));
      let updatedItem = null;
      const filtered = gridDataFilteredRef.current;
      const fullGrid = gridDataRef.current;
      const updated = filtered.map((item, index) => {
         const flag =
            item.customerID === customerID &&
            item.customerGroupID === customerGroupID &&
            item.productGroupID === productGroupID &&
            item.skuid === skuid;
         if (flag === true) {
            updatedItem = {
               ...item,
               hasError,
               quota: w,
               weekly5: !w ? 0 : w,
            };
            return updatedItem;
         }
         return item;
      });

      const updatedGrid = [];
      for (let i = 0; i < fullGrid.length; ++i) {
         const item = fullGrid[i];
         if(item.id === updatedItem.id) {
            updatedGrid.push(updatedItem);
         }
         else {
            updatedGrid.push(item);
         }
      }
      commitGridDataUpdate(dispatch, setState, {
         gridData: updatedGrid,
         gridDataFiltered: updated,
         updatedRow: updatedItem,
         backupFields: ["weekly5", "quota"],
      });
   }

   // function updateWeek5(event) {
   //    let w5 = removeComma(event.target.value);
   //    w5 = Number(w5);
   //    let w4 = Number(params.row.weekly4);
   //    const quota = w5;
   //    let hasError = false;
   //    setWeek5(w5);
   //    if(!w5 && w5!==0) {
   //       dispatch(setState("isError", true));
   //       dispatch(setState("isError_Info", "Only numbers are allowed."));
   //       return;
   //    }

   //    if(w4 > w5) {
   //       hasError = true;
   //    }
   //    dispatch(setState("gridDataChanged", true));
   //    updateGrid(hasError, w5, quota);
   //    dispatch(setTotalValues());
   // }

   const debouncedUpdate = useMemo(
      () =>
         debounce((hasError, w5) => {
            dispatch(setState("gridDataChanged", true));
            updateGrid(hasError, w5);
            dispatch(setTotalValues());
         }, QUOTA_CELL_DEBOUNCE_MS),
      [
         params.row?.customerID,
         params.row?.customerGroupID,
         params.row?.productGroupID,
         params.row?.skuid,
         params.row?.depletionModel,
         isFourWeekPeriod,
         isFiveWeekPeriod,
         dispatch,
      ]
   );

   useEffect(() => {
      return () => debouncedUpdate.cancel();
   }, [debouncedUpdate]);

   function updateWeek5(event) {
      let raw = removeComma(event.target.value);
      setDraft(raw);
      let w5 = Number(raw);
      const live =
         findGridRowByCustomerSku(gridDataFilteredRef.current, params.row) ??
         findGridRowByCustomerSku(gridDataRef.current, params.row) ??
         params.row;
      const dmLive = rowDepletionModelKey(live);
      const quotaRow = Number(live.quota);
      let hasError = false;
      if(!w5 && w5!==0) {
         dispatch(setState("isError", true));
         dispatch(setState("isError_Info", "Only numbers are allowed."));
         return;
      }

      if (
         dmLive !== "none" &&
         dmLive !== "biweekly" &&
         isFiveWeekPeriod &&
         !isFourWeekPeriod &&
         w5 !== quotaRow
      ) {
         hasError = true;
      }
      debouncedUpdate(hasError,w5);
   }

   function handleValidity(w4, w5){
      if (
         rowDm === "none" ||
         rowDm === "biweekly" ||
         isFourWeekPeriod ||
         !isFiveWeekPeriod
      ) {
         return;
      }
      if (Number(w5) !== Number(params.row.quota)) {
         dispatch(setState("isError", true));
         dispatch(setState("isError_Info", "Must equal quota"));
      }
   }

   if (shouldShowBlankWeekPlaceholder(5, params.row, gridDataFiltered)) {
      return <Box sx={{ width: 100 }} />;
   }

   return (
      <TextField
         disabled={
            !isWeekColumnEditable(
               5,
               params.row,
               selectedDepletionPeriodType
            )
         }
         variant="standard"
         value={displayValue}
         className={
            rowDm !== "none" &&
            rowDm !== "biweekly" &&
            !isFourWeekPeriod &&
            isFiveWeekPeriod &&
            Number(params.row.weekly5) !== Number(params.row.quota)
               ? "red-row"
               : ""
         }
         onChange={updateWeek5}
         onFocus={onFocus}
         onBlur={() => {
            debouncedUpdate.flush();
            onBlur();
            handleValidity(params.row.weekly4, params.row.weekly5);
         }}
         sx={{ width: 100 }}
      />
   );
}
